# TODO:
# ZZZ $ldj.Buy - pass container for more info?  render here?

# Online store - parameters/content
Store = $ldj.onlineStore

# PayPal forms and DOM elements
class PayPal
  
  @addToCartForm: null
  @displayCartForm: null
  
  @formsContainer: $ "#paypal-forms"
  @carts: $ ".shopping-cart"
  @creditCards: $ ".credit-cards"
  
  @initialize: ->
  
    @addToCartForm = new AddToCartForm @formsContainer
    @displayCartForm = new DisplayCartForm @formsContainer
  
    @carts.click (e) =>
      e.stopPropagation()
      gaEvent "clickBannerCart", ""
      @displayCartForm.submit()
    
    if @creditCards.length
      new CreditCards @creditCards
      new PayPalCartButton @creditCards, @displayCartForm


$(document).ready -> PayPal.initialize()

# Exported class
class $ldj.Buy
  
  constructor: (@container, @style, @infoCallback) ->
    
    @inStock = @style.stock>0
    
    @priceField = new Price @container, @style.price
    if Store.open
      if @inStock then @purchaseArea() else @notInStock()
    else
      @storeNotOpen()
    
    @terms()
    @infoLink()
  
  purchaseArea: ->
    @buyButtons = new Div @container
    @buyDirectCredit = => @buyButtons.div.slideUp(400, => @directCreditForm.show())
    @payPalButtons = new PayPalButtons @buyButtons, @style
    @divider()
    @directCreditButton = new DirectCreditButton @buyButtons, @style, @buyDirectCredit
    @directCreditForm = new DirectCreditForm @container, @style, Store.shippingCharge
  
  changePrice: (@style) ->
    # ZZZ relabel this method setStyle?
    @priceField.set @style.price
    @payPalButtons.setStyle @style
    @directCreditButton.setStyle @style
    @directCreditForm.setStyle @style
  
  storeNotOpen: ->
    @container.append $("<div>", html: Store.closedMessage, class: 'style-store-closed')
  
  notInStock: ->
    @container.append $("<div>", text: "Not in stock", class: "style-not-in-stock")
      
  divider: ->
    (new Div @buyButtons).append $("<div>", class: "buy-divider", text: "OR")
    
  terms: ->
    # ZZZ use CSS
    @container.append "<div style='display: block; margin-top: 20px;'>#{Store.terms}</div>"
    
  infoLink: ->
    @linkToInfo = $ "<a>",
      text: "Show more information below"
      class: "style-link-to-more-info"
      click: => @infoCallback()
    @container.append @linkToInfo


#-------------- Element superclasses --------------#

class Div
  
  constructor: (@container) ->
    @div = $ "<div>", class: "buy-container"
    @container.append @div
    
  append: (element) -> @div.append element


class BuyBox extends Div
  
  constructor: (@container) ->
    super @container
    @box = @div
    @box.addClass "buy-box"



#-------------- PayPal buttons --------------#

class PayPalButtons extends BuyBox
  
  constructor: (@container, @style) ->
    super @container
    @addToCartForm = PayPal.addToCartForm
    @setStyle @style
    @box.click(=>
      console.log "BOX CLICK"
      gaEvent "clickPayPalBuy", @style.id
      @addToCartForm.submit()
    )
    new BuyButton @box, "via credit card", "Add item to cart", (=>
      # Handled via @box.click above.  Otherwise, get two events.
    )
    new PayPalCartButton @box, PayPal.displayCartForm
    new CreditCards @box
    
  setStyle: (@style) ->
    @addToCartForm.setStyle @style


class PayPalCartButton
  
  constructor: (@container, @displayCartForm) ->
    
    @div = $("<div>", class: "buy-paypal-cart-container").appendTo @container
    
    @button = $ "<img>",
      class: "buy-paypal-cart-image"
      src: "/images/img/shopping-cart-grey-md.png" #"/images/img/view_cart.jpg"
      height: "20"
      title: "View cart"
      click: (e) =>
        e.stopPropagation()
        gaEvent "clickPayPalCart", ""
        @displayCartForm.submit()
    @div.append @button


class CreditCards
  
  constructor: (@container, @css) ->
    # ZZZ use CSS
    @div = $("<div>", class: "buy-credit-cards-container").appendTo(@container)
    images = Store.payPal.creditCardImages
    @div.append($ "<img>", src: "/images/img/#{img}", class: "buy-credit-card-image", height: "20") for img in images



#-------------- Direct credit button/form --------------#

class DirectCreditButton extends BuyBox
  
  constructor: (@container, @style, @buy) ->
    super @container
    @box.click(=> @buy())
    new BuyButton @box, "via direct deposit", "Buy via direct deposit (internet banking)", (=>
      gaEvent "clickDirectCreditBuy", @style.id
      @buy()
    )
    
  setStyle: (@style) ->


class DirectCreditForm extends Div
  
  constructor: (@container, @style, @shippingCharge) ->
    super @container
    @div.hide()
    #@div.css display: "none"
    
    #@totalCharge = parseFloat(@style.price) + parseFloat(@shippingCharge)
    
    @formContainer = $ "<div>", id: "direct-credit-form"
    @append @formContainer
    
    @form = $ "<form>",
      method: "post"
      action: "/direct-credit"  # ZZZ necessary?
    @formContainer.append @form
    
    @name = new NameField @form
    @email = new EmailField @form
    @shipping = new ShippingField @form
    @notes = new NotesField @form
    @fields = [@name, @email, @shipping, @notes]
    
    @submitContainer = $ "<div>", class: "buyfield send_order"
    @form.append @submitContainer
    @submit = $ "<input>",
      type: "button"
      id: "send_order"
      value: "Send order"
      click: => @submitOrder()
    @loading = $ "<div>", class: "loading"
      
    @div.append($("<div>", class: "clear"))
    
    @form.append(@submit).append(@loading)
    
    @preOrderMsg = $ "<div>", html: "<br>#{Store.directCredit.preOrderMessage}"
    @div.append @preOrderMsg
    
    @confirm = $ "<div>", css: {display: "none"}
    @container.append @confirm  # ZZZ base on event?
    # ZZZ add div class "loading"  #  <div class="loading"></div>
  
  setStyle: (@style) ->
  
  totalCharge: -> parseFloat(@style.price) + parseFloat(@shippingCharge)
  
  submitOrder: ->
    
    gaEvent "submitDirectCreditOrder", "#{@style.id}: #{@email.val()}"
    fbEvent @style.id
    
    ok = true
    (ok = false unless field.validate()) for field in @fields  # ZZZ is there an iterator for this?
    return if not ok
    
    time = new Date().getTime()  # ms
    orderRef = Math.floor(time / 1000) % 432000 + 100000
    
    options = if @style.options then " - #{@style.options}" else ""
    
    data = "name=#{@name.val()}"+
      "&email=#{encodeURIComponent(@email.val())}"+
      "&shipping=#{encodeURIComponent(@shipping.val())}"+
      "&notes=#{encodeURIComponent(@notes.val())}"+
      "&id=#{encodeURIComponent(@style.id)}"+
      "&style=#{encodeURIComponent(@style.name + options)}"+
      "&price=#{@style.price}"+
      "&shipcharge=#{@shippingCharge}"+
      "&ref=#{orderRef}"
    # ZZZ loop over fields and encode all?
    
    # Disable fields
    field.input.attr "disabled", true for field in @fields
    
    # Loading icon
    @loading.show()
    
    console.log "ajax data", data
    
    # Template - order conformation
    account = Store.directCredit.accountNumber
    bank = Store.directCredit.bank
    amount = @totalCharge()
    template = _.template(Store.directCredit.orderConfirmation.trim())
    html = template {account, bank, orderRef, amount}
    @confirm.append html
    
    $.ajax
      url: "/direct-credit"
      type: "GET"
      data: data
      cache: false
      success: (result) =>
        console.log "result", result
        @loading.fadeOut "slow"
        if result.ok
##          $(".success-message").slideDown "slow"
          gaEvent "successfulDirectCreditOrder", "#{@style.id}: #{@email.val()}"
          @preOrderMsg.hide()
          @submit.slideUp(400, => @confirm.slideDown())
        else
          gaEvent "failDirectCreditOrder", "#{@style.id}: #{@email.val()}"
          alert "Sorry, unexpected error. Please try again later."
  
  show: (show=true) -> @div.slideDown()


class FormField
  
  tag: "<input>"
  name: "unknown"
  type: "text"
  placeholder: "text"
  inputClass: "text"
  validationErrorClass: "buy-validation-error"
  
  constructor: (@container) ->
    
    @field = $ "<div>", class: "buyfield"
    @container.append @field
    
    @animateSpeed = 300
    
    @input = $(@tag,
      type: @type
      name: @name
      class: @inputClass
      placeholder: @placeholder
      blur: => @validate()
    )
    
    @field.append @input
    
  validate: ->
    valid = @valid()
    @input.addClass @validationErrorClass, @animateSpeed if not valid
    @input.removeClass @validationErrorClass, @animateSpeed if valid
    valid
  
  valid: -> @val() isnt ""
  
  val: -> @input.val()


class NameField extends FormField
  
  name: "name"
  placeholder: "Name"


class EmailField extends FormField
  
  name: "email"
  placeholder: "email"
  emailReg: /^[a-zA-Z0-9._-]+@([a-zA-Z0-9.-]+\.)+[a-zA-Z0-9.-]{2,4}$/
# DEBUG valid: -> @emailReg.test @input.val()


class ShippingField extends FormField
  
  tag: "<textarea>"
  name: "shipping"
  placeholder: "Shipping address"
  inputClass: "text textarea"


class NotesField extends FormField
    
  constructor: (@container) ->
    super @container
    @input.addClass "buy-notes-field"
  
  tag: "<textarea>"
  name: "notes"
  placeholder: "Special instructions"
  inputClass: "text textarea"
  valid: -> true



#-------------- General - price, buy button --------------#

class Price extends Div
  
  constructor: (@container, @price) ->
    super @container
    # ZZZ CSS
    @div.css 
      marginBottom: "15px"
      textAlign: "center"
    @priceElement = $ "<span>", class: "buy-price"
    @currency = $ "<span>", class: "buy-currency", text: " NZD"
    @div.append(@priceElement).append(@currency)
    @set @price
    
  set: (@price) ->
    @priceElement.text "$"+@price


class BuyButton
  
  constructor: (@container, @text, @title, @callback) ->
    
    @div = $ "<div>", class: "buy-button-container"
    @container.append @div
    
    # Image button causes jumpiness in main image frame (not sure why)
    # Helped when I restarted Safari
    #@button = $ "<img>"
      #height: "10"
      #src: "/images/img/add_to_cart.png"
      #title: @title
      #css:
      # float: "left"
      # cursor: "pointer"
      #click: => @callback()
      
    @button = $ "<div>",
      class: "buy-button"
      text: "Buy"
      click: => @callback()
      
    @div.append @button
    
    txt = $ "<div>", class: "buy-button-text", text: @text
    @div.append txt



#-------------- PayPal forms --------------#

class PayPalForm
  
  @paypalSite: if window.location.hostname is "louisedouglas.dev" then Store.payPal.sandboxSite else Store.payPal.site
  @business: Store.payPal.business #"CDYL3S3NJ22CU"
  @logo: Store.payPal.logo
  @paypalNotifyUrl: Store.payPal.notifyUrl
  
  constructor: (@container) ->
    @form = $ "<form>",
      action: "https://" + PayPalForm.paypalSite + "/cgi-bin/webscr"
      method: "post"
      target: "paypal"  # ZZZ only for cart?  only for add to cart?  separate tab?
    @container.append @form
    url = window.location.href
  
  submit: ->
    console.log "notify", PayPalForm.paypalNotifyUrl
    @form[0].submit()
  
  standardFields: ->
    @field "business", PayPalForm.business
    @field "notify_url", PayPalForm.paypalNotifyUrl
    @addImages()
    @addReturnUrl()
    #@paypalPixel()
    
  addImages: ->
    # Not working yet.  Setup logo on paypal site (profile, selling tools, custom...).
    return
    #@field "image_url", @logo
    @field "cpp_logo_image", @logo  # This is the one that appears on the checkout page.
    @field "cpp_header_image", @logo
  
  addReturnUrl: ->
    url = window.location.href
    @field "return", url
    #@field "cancel_return", url
    
  paypalPixel: ->
    img = $ "<img>",
      alt: ""
      border: "0"
      src: "https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
      width: "1"
      height: "1"
    @form.append img
    
  field: (name, val) ->
    input = $ "<input>",
      type: "hidden"
      name: name
      value: val
    @form.append input
    input
    
  setField: (field, val) -> field.attr "value", val


class AddToCartForm extends PayPalForm
  
  constructor: (@container) ->
    super @container
    @field "cmd", "_cart"
    # Buy now: "_xclick"
    @field "add", "1"
    #@field "discount_rate", "15"
    @styleId = @field "item_number", ""
    @styleName = @field "item_name", ""
    @stylePrice = @field "amount", ""
    @field "currency_code", "NZD"
    @standardFields()
    
  setStyle: (@style) ->
    @setField @styleId, @style.id
    options = if @style.options then " (#{@style.options})" else ""
    @setField @styleName, @style.name + options
    @setField @stylePrice, @style.price + ".00"


class DisplayCartForm extends PayPalForm
  
  constructor: (@container) ->
    super @container
    @field "cmd", "_cart"
    @field "display", "1"
    @standardFields()


